import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';

import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { IHinhThucGui } from './hinh-thuc-gui';

@Injectable()

export class HinhThucGuiService {
    constructor(private http: Http) {
     }
   
    GetList(idTinhThanh) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdTinhThanh: idTinhThanh};
        return this.http.post(Config.apiUrl + 'HinhThucGui/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }

    Save(item?:IHinhThucGui) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'HinhThucGui/Save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    Delete(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'HinhThucGui/Delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetListFromPagination(idTinhThanh:number, paging:number, keyword: string, pageSize: number) {
        let headers = new Headers();
        let startRowIndex = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {startRowIndex, pageSize};
        return this.http.get(Config.apiUrl + 'HinhThucGui/PaginationDSHinhThucGui?idtinhthanh=' + idTinhThanh + '&offset=' + startRowIndex + "&pagesize=" + pageSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/hinh-thuc-gui/hinh-thuc-gui.service.ts